import { render } from "./CustomerDataComponent.vue?vue&type=template&id=deb92d60"
import script from "./CustomerDataComponent.vue?vue&type=script&lang=js"
export * from "./CustomerDataComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__